import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { AppRoute } from '@app/core/routing/AppRoute';
import { DefaultStationRedirect } from '@app/core/routing/DefaultStationRedirect';
import { SocialExportUploadPage } from '@app/modules/fragments/screens/upload/SocialExportUploadPage';
import { Switch } from 'react-router-dom';
import { FragmentsListStationPage } from '../screens/list/FragmentsListStationPage';
import { FragmentsViewPage } from '../screens/view/FragmentsViewPage';
import { Fragment } from '../types';

/**
 * Route state when opening fragment view from the list so the header can render
 * before the fragment detail query resolves.
 */
export interface FragmentViewNavigationState {
  fragment?: FragmentListItemDto;
}

export const routeGenerator = {
  list: (stationId: string) => `/fragments/s/${stationId}`,
  view: (fragment: Fragment | string) =>
    `/fragments/${typeof fragment === 'string' ? fragment : fragment.id}`,
  upload: (fragment: Fragment, platform: { id: string }, editId?: string) => {
    const base = `/fragments/${fragment.id}/upload/${platform.id.toLowerCase()}`;
    return editId ? `${base}?editId=${encodeURIComponent(editId)}` : base;
  },
};

export function FragmentsRoutes() {
  return (
    <Switch>
      <AppRoute
        path={`/fragments/:fragmentId/upload/:platform`}
        component={SocialExportUploadPage}
      />
      <AppRoute exact path={`/fragments/s/:slug`} component={FragmentsListStationPage} />
      <AppRoute path={`/fragments/:fragmentId`} component={FragmentsViewPage} />

      {/* catch all: redirect to most recent station or first station */}
      <DefaultStationRedirect to={(s) => `/fragments/s/${s.slug}`} />
    </Switch>
  );
}
